import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    showModal = false;
    title = 'kornerstone';
    textField = null;
    estimateData = null;
    showTaskModal = false;
    newTask = null;
    stories = false;
    @BlockUI() blockUI: NgBlockUI;
    estimates = false;
    exceededCount = false;
    registerForm: FormGroup;
    storyPoint = null;
    constructor(private http: HttpClient, private formBuilder: FormBuilder) {
        const usedCount = localStorage.getItem('usedCount');
        if (usedCount === '2') {
            this.exceededCount = true;
        } else {
            this.showModal = true;
        }
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    closeModal(): void {
        if (!this.registerForm.invalid) {
            this.gatherUserInfo(this.registerForm.value.email, this.registerForm.value.firstName.toLowerCase()).subscribe((res) => {
                console.log(res);
                localStorage.setItem('Session', res.session);
                this.showModal = false;
            });
        } else {
            window.alert('Enter Name and Email');
        }
    }

    getStoriesCall(): Observable<any> {
        return this.http.post<any>('https://estimate.zymmr.com/usep/tasks-from-story', {
            story: this.textField,
            session: localStorage.getItem('Session')
        });
    }

    getStories(): void {
        let count = parseInt(localStorage.getItem('usedCount'));
        count = isNaN(count) ? 0 : count;
        if (count === null || count === undefined || count < 2) {
            if (this.textField) {
                this.stories = true;
                this.blockUI.start();
                this.getStoriesCall().subscribe(res => {
                    this.estimateData = res.tasks;
                    this.blockUI.stop();
                }, error => {
                    this.blockUI.stop();
                });
                count++;
                localStorage.setItem('usedCount', count.toString());
            }
        } else {
            this.exceededCount = true;
        }
    }

    addTask(): void {
        this.showTaskModal = true;
        this.newTask = null;
    }

    addNewTaskToTable(): void {
        if (this.newTask) {
            this.showTaskModal = false;
            const param = {
                task_desc: this.newTask,
                action: 'C', story_id: this.estimateData[0].story_id
            };
            this.estimateData.push(param);
        }
    }

    showEstimate(): void {
        this.blockUI.start();
        this.updateTasks().subscribe(res => {
            this.getEstimates().subscribe(est => {
                this.estimateData = est.estimates;
                this.storyPoint = est.story_point;
                console.log('===>',this.estimateData);
                this.blockUI.stop();
                this.estimates = true;
            });

        }, error => {
            this.blockUI.stop();
        });
    }

    updateTasks(): Observable<any> {
        this.estimateData.forEach(ele => {
            if (ele?.action) {
            } else {
                ele.action = 'NC';
            }
        });
        return this.http.post<any>('https://estimate.zymmr.com/usep/update-story-tasks', {tasks: this.estimateData});
    }

    gatherUserInfo(email: string, full_name: string): Observable<any> {
        return this.http.post<any>('https://estimate.zymmr.com/usep/add-users/', {email, full_name});
    }

    getEstimates(): Observable<any> {
        return this.http.post<any>('https://estimate.zymmr.com/usep/generate-estimates-for-story', {story_id: this.estimateData[0].story_id});
    }

    close(): void {
        this.stories = false;
        this.textField = null;
        this.estimateData = null;
        this.estimates = false;
        this.storyPoint = null;
    }
}
